export default __webpack_public_path__ + "static/media/cc_1.942886ea.mp3";